export const dayangMenus = [
    // {
    //     title: '合同管理', key: 'dayang_ht',icon:'icon iconfont icon-hetongguanli-', compTypes: [4], children: [
    //         { title: '销售合同模板', key: '/dayang/htmb',icon:'icon iconfont icon-icon-test2' },
    //         { title: '设计奖补入驻申请', key: '/dayang/allowance',icon:'icon iconfont icon-icon-test2' }
    //     ]
    // },
];